import { Outlet } from "react-router-dom"
import FullHeightContent from "../components/FullHeightContent"
import NavBar from "../components/navbars/NavBar"
import { Box, Toolbar } from "@mui/material"
import BottomNavBar from "../components/navbars/BottomAppBar"

function MainPageLayout() {
  return (
    <FullHeightContent>
      <NavBar />
      <Box id="main" component="main" textAlign="center" sx={{ flexGrow: 1, bgcolor: "transparent" }}>
        <Toolbar />
        <Outlet />
      </Box>
      <BottomNavBar />
    </FullHeightContent>
  )
}

export default MainPageLayout